export default {
    name: 'reportsMovements',
    component: () => import(/* webpackChunkName: "reports-movements-Layout" */ '@/modules/reports/movements/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.reports.movements.index',
            component: () => import(/* webpackChunkName: "reports-movements-index" */ '@/modules/reports/movements/views/Index'),
        },
    ]
}